const TedSearchIcon = () => (
  <div>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.66667 14.0026C11.1645 14.0026 14 11.1671 14 7.66927C14 4.17147 11.1645 1.33594 7.66667 1.33594C4.16886 1.33594 1.33333 4.17147 1.33333 7.66927C1.33333 11.1671 4.16886 14.0026 7.66667 14.0026Z"
        stroke="#545454"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 14.6693L13.3333 13.3359"
        stroke="#545454"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default TedSearchIcon;
